export default __webpack_public_path__ + "static/media/18.34851634.jpeg";